import { DWFileUpload } from 'src/components/file-upload';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWFileUpload.displayName, DWFileUpload);

export default DWFileUpload;
export { DWFileUpload };
